@import '../../../../../../../constants/spacing.module.less';

.table-information {
  gap: @space-16;
  color: var(--gray-637381);

  svg {
    width: 12px;
    margin-right: @space-4;
  }
}
